import type { ContentTemplate } from '@/types/stylepacks.types';
import blAuth from '../bl-auth/bl-auth';
import { Get } from '../helpers';

const GetStylepacks = () => {
  return Get<{ templates: ContentTemplate[] }>({
    host: import.meta.env.VITE_GREENROOM_API,
    url: '/v2/greenroom/generate-content/templates',
    headers: {
      'bl-token': blAuth.idToken ?? '',
      'bl-global-resource': 'false',
    },
    useCache: true,
    cacheTtl: 300,
  });
};

export default GetStylepacks;
